import request from '@/utils/request';

export function getDepartments() {
  return request({
    url: '/api/user/departments',
    method: 'get'
  });
}

export function getUsers() {
  return request({
    url: '/api/user/users',
    method: 'get'
  });
}

export function switchOtherUserLogin(open_id) {
  return request({
    url: '/api/user/change-user-by-super',
    method: 'get',
    params:{
      open_id
    }
  });
}

export function getCompanys() {
  return request({
    url: '/api/user/companys',
    method: 'get'
  });
}

// 获取用户和部门列表逻辑
let ROOTDEP = {
  deptId: '0',
  deptName: '观脉科技（北京）有限公司'
}
let USERS = []
let DEPARTMENTS = []
let USER_MAP = {}
let DEPARTMENT_MAP = {}
const resetUserData = () => {
  USERS = []
  DEPARTMENTS = []
  USER_MAP = []
  DEPARTMENT_MAP = []
}
export const initUserAndDepartments = async () => {
  resetUserData()
  const [depRes, userRes] = await Promise.all([getDepartments(), getUsers()])
  USERS = userRes && userRes.code === 0 ? userRes.data : []
  DEPARTMENTS = depRes && depRes.code === 0 ? depRes.data : []
  USERS.forEach(item => {
    USER_MAP[item.open_id] = item
  })
  DEPARTMENTS.forEach(item => {
    DEPARTMENT_MAP[item.open_department_id] = item
  })
  return Promise.resolve({
    USERS,
    DEPARTMENTS,
    DEPARTMENT_MAP,
    USER_MAP
  })
}


export const GET_DEPT_ROOT = async () => {
  await initUserAndDepartments()
  return Promise.resolve({
    'code': 200,
    'msg': '获取成功',
    'data': JSON.parse(JSON.stringify(ROOTDEP))
  })
}

// 根据部门id获取分页人员信息F
// export const GET_PAGE_EMPLOYEE = data => get( BASE_URL + 'userData.json', data )
export const GET_PAGE_EMPLOYEE = data => {
  return Promise.resolve({
    'code': 200,
    'msg': '获取成功',
    'data': [
      {
        'deptId': 111,
        'deptName': '研发1部',
        'parentDeptId': 1
      },
      {
        'userId': 20,
        'userName': '张三',
        'deptId': 1,
        'pid': 2
      },
      {
        'userId': 30,
        'userName': '李四',
        'deptId': 1
      },
      {
        'userId': 40,
        'userName': '王五',
        'deptId': 1
      },
      {
        'userId': 50,
        'userName': '二麻子',
        'deptId': 1
      },
      {
        'userId': 60,
        'userName': '富贵',
        'deptId': 1
      }
    ]
  })
}

// 获取组织机构子节点
// export const GET_DEPT_TREE = data => get(BASE_URL + 'depChild.json', data)
export const GET_DEPT_TREE = async data => {
  if (Array.isArray(DEPARTMENTS) && DEPARTMENTS.length <= 0) {
    await initUserAndDepartments()
  }
  const child_deps = []
  const child_users = []
  let chooseDeptItem = DEPARTMENT_MAP[data.deptId]
  if (data.deptId == ROOTDEP.deptId) {
    chooseDeptItem = { open_department_id: ROOTDEP.deptId }
  }

  DEPARTMENTS.forEach(item => {
    if (item.parent_department_id == chooseDeptItem.open_department_id) {
      child_deps.push({
        deptId: item.open_department_id,
        deptName: item.name,
        parentDeptId: item.parent_department_id
      })
    }
  })

  USERS.forEach(item => {
    if (item.department_ids.includes(chooseDeptItem.open_department_id)) {
      child_users.push({
        userId: item.open_id,
        userName: item.name,
        deptId: item.department_ids[0]
      })
    }
  })

  const childrens = [].concat(child_deps, child_users)

  return Promise.resolve({
    code: 200,
    msg: '成功',
    data: childrens
  })

  return Promise.resolve({
    'code': 200,
    'msg': '获取成功',
    'data': [
      {
        'deptId': 2,
        'deptName': 'xxx财务部',
        'parentDeptId': 1
      },
      {
        'deptId': 3,
        'deptName': 'xxx行政部',
        'parentDeptId': 1
      },
      {
        'deptId': 4,
        'deptName': 'xxx研发部',
        'parentDeptId': 1
      },
      {
        'deptId': 5,
        'deptName': 'xxx工程部',
        'parentDeptId': 1
      },
      {
        'deptId': 6,
        'deptName': 'xxx后勤部',
        'parentDeptId': 1
      }
    ]
  })
}

// 获取组织机构下人员信息
// export const GET_USER_BY_DEPT = data => get(BASE_URL + 'userData.json', data)
export const GET_USER_BY_DEPT = data => {
  return Promise.resolve({
    'code': 200,
    'msg': '获取成功',
    'data': [
      {
        'userId': 20,
        'userName': '张三',
        'deptId': 1
      },
      {
        'userId': 30,
        'userName': '李四',
        'deptId': 1
      },
      {
        'userId': 40,
        'userName': '王五',
        'deptId': 1
      },
      {
        'userId': 50,
        'userName': '二麻子',
        'deptId': 1
      },
      {
        'userId': 60,
        'userName': '富贵',
        'deptId': 1
      }
    ]
  })
}

// const emptyData = {
//   'code': 200,
//   'msg': '获取成功',
//   'data': []
// }
initUserAndDepartments();
